(() => {
document.addEventListener('DOMContentLoaded', function() {
    var containers = [
        document.querySelector('.prod-head-gallery'),
        document.querySelector('.gallery-grid.grid_section')
    ].filter(Boolean);
    var postIdMatch = document.body.className.match(/postid-(\d+)/);
    var galleryId = postIdMatch ? postIdMatch[1] : 'gallery';
    var relValue = 'prettyPhoto[prod-gallery-' + galleryId + ']';
    containers.forEach(function(container) {
        var links = container.querySelectorAll('a.qode-prettyphoto');
        links.forEach(function(link) {
            link.setAttribute('rel', relValue);
            link.setAttribute('data-rel', relValue);
        });
    });
    if (containers.length && window.jQuery && jQuery().prettyPhoto) setTimeout(function() {
        // Only the gallery links, never every a.qode-prettyphoto on the page -
        // a global rebind would drop the parent theme's settings from VC single
        // images (horizontal_padding, viewport_padding, hide-navigation callback).
        var $links = jQuery(containers).find('a.qode-prettyphoto');
        $links.off('click.prettyphoto').removeData('prettyPhoto');
        $links.prettyPhoto({
            theme: 'pp_default',
            horizontal_padding: 0,
            viewport_padding: 20,
            social_tools: false,
            deeplinking: false
        });
    }, 100);
});

})();
//# sourceMappingURL=lightbox-gallery.js.map
